import React from "react";

const PreviewProfileButton = ({ user }) => {
  if (!user?._id) return null;

  const href = user.role === "institution" ? `/academy/${user._id}` : `/tutor/${user._id}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="preview-profile-btn"
    >
      Preview Public Profile ↗
    </a>
  );
};

export default PreviewProfileButton;
